export default "__VITE_ASSET__ByNiYp_d__"